import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { TranslationService } from 'src/app/shared';
import { WebContentTypeService } from 'src/app/web-content/shared/web-content-type.service';
import { FileUploadMetadataLego } from '../../shared/dto/file-upload-metadata-lego';
import { Optional, SkipSelf } from '@angular/core';

@Component({
  selector: 'wl-file-upload-lego-edit',
  templateUrl: './file-upload-lego-edit.component.html',
  styleUrls: ['./file-upload-lego-edit.component.less'],
  viewProviders: [
  {
    provide: ControlContainer,
    useFactory: (container: ControlContainer) => container,
    deps: [[new Optional(), new SkipSelf(), ControlContainer]]
  }],
    standalone: false
})
export class FileUploadLegoEditComponent implements OnInit {
  @Input() fileUploadData: FileUploadMetadataLego;
  webContentTypeOptions: Array<SelectItem>;
  constructor(private _webContentTypeService: WebContentTypeService) {}

  ngOnInit(): void {
    this._webContentTypeService.getWebContentTypes().then((data) => {
      this.webContentTypeOptions = data.Result.map((x) => {
        return { label: x.ContentType, value: x.ContentTypeID } as SelectItem;
      });
    });
  }
}
